import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import theme from "../theme";

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  text-align: center;
`;

export const EmptyStateText = styled(Typography)`
  font-size: 14px;
  color: ${theme.palette.grey[600]};
  margin-top: 8px;
`;
